<template>
  <div
    @focus="handleFocus"
    @focusout="handleFocusOut"
    tabindex="0"
    v-if="isSidebarActiveLocal"
    ref="frame"
    :class="isSidebarActiveLocal ? 'active' : ''" class="product-pop-cont">
    <div class="pop-frame" tabindex="1">
      <div class="pop-top">
        <h4>{{ dataProp.edit ? 'EDIT PRODUCT' : 'ADD TO CART' }}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
      </div>
      <div class="pop-main">
        <div v-if="dataProp.photoUrl" class="pop-product-image" v-bind:style="{ 'background-image': 'url(' + dataProp.photoUrl + ')' }" >
        </div>
        <div class="pop-product-name">
          <span>{{(dataProp.section) ? dataProp.section.name : ''}}</span>
            <h2>{{ dataProp.name }}</h2>
            <p>{{dataProp.description}}</p>
            <div class="tag-container" v-if="dataProp.tags.length>0">
              <div v-for="(tag, tagIndex) in dataProp.tags" :key="tagIndex" :class="`tag-${tag.value}`">{{tag.label}}</div>
            </div>
        </div>

        <div class="alert__container" v-if="checkValidity">
          <div class="alert alert__warning" role="alert">
            <feather-icon icon="AlertTriangleIcon" class="warning" svgClasses="h-5 w-5" />
            <p class="alert__text">Temporarily unavailable</p>
          </div>
        </div>
        <!-- CATERING OPTIONS -->
        <div class="pop-catering-options" v-if="dataProp.is_catering">
          <div class="cater-option">
            <div class="cater-option-col">
              <select v-model="quantity">
                <option :value="index" v-for="index in 50" :key="index">{{index}} {{ dataProp.quantity_unit }}</option>
              </select>
            </div>
            <div class="cater-option-col">{{ dataProp.quantity_description }}</div>
          </div>
        </div>
        <!-- CATERING OPTIONS -->
        <div class="pop-product-options">
          <div v-if="size  !== null"  class="padding-spacer size-item modifier required" >
            <label class="vs-input--label">{{size.instructions}}</label>

            <div class="w-full flex tr-size-section">
              <vs-radio v-model="sizeRadioValue"
                        :vs-value="size_item.id"
                        v-for="size_item in size.items"
                        :key="size_item.id"
                        class="mr-4 tr-size-section-label"
                        vs-name="size-product">{{ size_item.name }} - ${{ formatPrice(size_item.price) }}</vs-radio>

            </div>
            <span class="text-danger text-sm"
                  v-show="errors.has('size')">{{ errors.first('size') }}</span>
          </div>

          <div v-if="hasModifiers.length > 0" v-for="(modifier, index) in hasModifiers"
               class="modifier padding-spacer size-item"
               :ref="'mod'.concat(modifier.id)"
               :id="'mod'.concat(modifier.id)"
               :class="(modifier.modifier.required_choice === 1) ? 'required' : ''"
               v-bind:key="index" >
            <label class="vs-input--label">{{modifier.modifier.instructions}}</label>
            <div v-if="modifier.modifier.how_many_choices === 2">
              <vs-checkbox
                v-bind:key="check_item.id"
                v-for="(check_item, check_item_index) in modifier.modifier.items"
                @change="onModifierCheckChange(modifier,index, check_item_index, $event)"
                :checked="(modifier.modifier.selected_value) ? modifier.modifier.selected_value.value === check_item.id : false"
                :name="'mod'.concat(check_item.id)"
                v-validate="(modifier.modifier.required_choice === 1 && Array.isArray(modifier.modifier.selected_value)) ? 'required' : ''"
                class="">{{(check_item.price !== 0) ? `${check_item.name} - $${formatPrice(check_item.price)}` : check_item.name}}</vs-checkbox>
            </div>

            <div v-else-if="modifier.modifier.how_many_choices === 3"
                 v-bind:key="check_item.id" v-for="(check_item, check_item_index) in modifier.modifier.items">
              <vs-checkbox :checked="(modifier.modifier.selected_value) ? ((modifier.modifier.selected_value.filter(function (el) {return el.value === check_item.id}).length > 0) ? true : false) : false"
                           @change="onModifierCheckChange(modifier,index, check_item_index, $event)"
                           :name="'mod'.concat(modifier.id)"
                           v-validate="(modifier.modifier.required_choice === 1 && Array.isArray(modifier.modifier.selected_value)) ? 'required' : ''"
                           class="">{{(check_item.price !== 0) ? `${check_item.name} - $${formatPrice(check_item.price)}` : check_item.name}}</vs-checkbox>
            </div>
            <div v-else
                 v-bind:key="check_item.id" v-for="(check_item, check_item_index) in modifier.modifier.items">
              <vs-checkbox :checked="(modifier.modifier.selected_value) ? ((modifier.modifier.selected_value .length > 0) ? modifier.modifier.selected_value.filter(function (el) {return el.value === check_item.id})[0] === check_item.id : false) : false"
                           @change="onModifierCheckChange(modifier,index, check_item_index, $event)"
                           :ref="'mod'.concat(check_item.id)"
                           v-validate="isModifierRequired(modifier)"
                           class="">{{(check_item.price !== 0) ? `${check_item.name} - $${formatPrice(check_item.price)}` : check_item.name}}</vs-checkbox>
            </div>
            <span class="text-danger text-sm"
                  v-show="errors.has('mod'.concat(modifier.modifier.id))">{{ String(errors.first('mod'.concat(modifier.modifier.id))).replace('mod'.concat(modifier.modifier.id), modifier.modifier.name) }}</span>
          </div>

          <div v-if="!dataProp.edit && complete_your_meal_products  !== null"  class="padding-spacer size-item modifier">
            <label class="vs-input--label">Complete Your Meal</label>
            <complete-product :checkChange="completeProductChange"
                              :data="product" :key="index"
                              :ref="`complete${product.id}`"
                              v-for="(product, index) in complete_your_meal_products" />
            <span class="text-danger text-sm"
                  v-show="errors.has('size')">{{ errors.first('size') }}</span>
          </div>

        </div>
      </div>
      <div class="pop-footer">
        <div class="pop-quantity">
          <div class="quantity-button" v-if="!dataProp.is_catering">
            <button @click="removeQuantity()">-</button>
            <input tabindex="0" type="number" v-model="quantity" placeholder="1" min="1" max="10" pattern="\d*"/>
            <button @click="addQuantity()">+</button>
          </div>
        </div>
        <div class="pop-add-button" @click="submitData">
          <div class="pop-add-item">{{ dataProp.edit ? 'Save Changes' : 'Add to Cart' }}:<br>${{formatPrice(price * quantity)}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import CompleteProduct from './components/CompleteProduct'


export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    dataProp: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    CompleteProduct
  },
  metaInfo () {
    return {
      title: this.dataProp.name,
      titleTemplate: `%s | ${this.restaurant ? this.restaurant.user_property['Restaurant-Name'] : 'Turkish Restaurant'}`,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.dataProp.description
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: `${this.dataProp.name}`
        }
      ]
    }
  },
  data () {
    return {
      sizeRadioValue: 0,
      restaurantId: null,
      productId: null,
      dataImg: null,
      uploadImg: null,
      name: '',
      description: '',
      sizeType: 'single',
      sizeId: null,
      size: null,
      price: 0,
      basePrice: 0,
      section: null,
      sectionId: null,
      progress: 0,
      quantity: 1,
      complete_your_meal: [],
      complete_your_meal_products: null,
      selected_complete_your_meal_products: [],
      hasModifiers: {
        type: Array
      },
      mobile:window.innerWidth <= 700,
      size_selected_value: null,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      cart_product: {},
      isAlertOff: true,
      showLayout: false
    }
  },
  mounted () {
    //this.getSectionOptionsList()
  },
  beforeDestroy () {
    this.isSidebarActiveLocal = false
  },
  watch: {
    quantity () {
    },
    sizeRadioValue (val) {
      if (!val) {
        return
      }

      const size_val = this.getSizeOptionsForSelect(this.size)[val]
      this.size.selected_value = size_val
      this.size_selected_value = size_val
      this.handlePriceChange()
    },
    isSidebarActive (val) {
      if (!val) {
        return
      }

      const {name, id, price, complete_your_meal, description, restaurant_id, size, section, size_id, section_id, hasModifiers, quantity, photoUrl} = JSON.parse(JSON.stringify(this.dataProp))

      this.productId = id
      this.name = name
      this.price = price
      this.quantity = quantity
      this.basePrice = price
      this.description = description
      this.restaurantId = restaurant_id
      this.hasModifiers = hasModifiers
      this.section = section
      this.sizeId = size_id
      this.sectionId = section_id
      this.dataImg = photoUrl

      if (complete_your_meal !== false) {
        this.complete_your_meal = complete_your_meal
      }

      if (this.dataProp.edit) {

        if (size !== null) {
          this.size = size
          this.price = this.size.items[0].price
          this.size_selected_value = this.size.selected_value
          this.sizeRadioValue = this.size_selected_value.value
        }


      } else if (size !== null) {
        this.size = size
        if (price === 0) {
          this.sizeType = 'multiple'
        }
        this.price = size.items[0].price
        this.size_selected_value = this.getSizeOptionsForSelect(this.size)[this.size.items[0].id]
        this.sizeRadioValue = this.size_selected_value.value
      }

      this.getCompleteProducts((result) => {
        this.complete_your_meal_products = result
      })

      this.handlePriceChange()
      this.showLayout = true
      return true
    }
  },
  computed: {
    checkValidity () {
      const now = new Date()
      if (!this.dataProp.is_available) {
        if (this.dataProp.disabled_until !== '' && this.dataProp.disabled_until !== 'null') {
          if (now < new Date(this.dataProp.disabled_until)) {
            return true
          }
        }

        if (this.dataProp.disabled_period !== '' && this.dataProp.disabled_period !== 'null') {
          const period = JSON.parse(this.dataProp.disabled_period)

          if (period.length > 0) {
            const todays_index = now.getDay()
            if (period.includes(todays_index)) {
              return true
            }
          }
        }
      }
      return false
    },
    restaurant () {
      return this.$store.state.api.restaurant
    },
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          if (this.isAlertOff) {
            this.resetForm()
          }
        }
      }
    },
    isFormValid () {
      return !this.errors.any()
    },
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    },
    cartItems () {
      return this.$store.state.eCommerce.cartItems.slice().reverse()
    },
    isCatering () {
      const has_catering_products = this.cartItems.filter(item => {
        if (item.is_catering) {
          return item
        }
      })
      return has_catering_products.length > 0
    }

  },
  methods: {
    checkDateValidity () {
      const now = new Date()
      if (now < new Date(this.dataProp.disabled_until)) {
        return true
      }
      return false
    },
    addQuantity () {
      if (this.quantity < 11) {
        this.quantity += 1
      }
    },
    removeQuantity () {
      if (this.restaurant) {
        if (this.quantity > 1) {
          this.quantity -= 1
        }
      } else if (this.quantity > this.dataProp.min_qty) {
        this.quantity -= 1
      }

    },
    updateItemQuantity (event, index) {
      const itemIndex = Math.abs(index + 1 - this.cartItems.length)
      this.$store.dispatch('eCommerce/updateItemQuantity', { quantity: event, index: itemIndex })
    },
    openAlert (title, text, accept) {
      this.$vs.dialog({
        type:'alert',
        color: 'warning',
        notClose: true,
        acceptText: 'Ok',
        title,
        text,
        accept
      })
    },
    handleFocus () {
      // do something here
      this.isSidebarActiveLocal = false
    },
    handleFocusOut () {
      // do something here
    },
    completeProductChange (is_checked, complete_product) {

      if (is_checked) {
        let index = -1
        index = this.selected_complete_your_meal_products.map(x => {
          return x.id
        }).indexOf(complete_product.id)
        if (index !== -1) {
          this.selected_complete_your_meal_products.splice(index, 1)
        }
        this.selected_complete_your_meal_products.push(complete_product)
      } else {
        const index = this.selected_complete_your_meal_products.map(x => {
          return x.id
        }).indexOf(complete_product.id)
        this.selected_complete_your_meal_products.splice(index, 1)
      }

      this.handlePriceChange()
    },
    getCompleteProducts (callback) {
      const comp_products = []
      this.complete_your_meal.map((item, index) => {
        // Loading
        const payload = {
          productId: item
        }

        this.$store.dispatch('api/getProduct', payload)
          .then((response) => {
            comp_products.push(response)
            if (index === this.complete_your_meal.length - 1) {
              callback(comp_products)
            }
          })
          .catch(error => {
            this.$vs.notify({
              title: 'Error',
              text: error.message,
              iconPack: 'feather',
              icon: 'icon-F-circle',
              color: 'danger'
            })
          })

      })
    },
    handlePriceChange () {
      const self = this
      if (this.size) {
        this.price = this.size_selected_value.price
      } else {
        this.price = this.basePrice
      }
      this.hasModifiers.forEach(function (key) {
        if (typeof key.modifier.selected_value !== 'undefined' || key.modifier.selected_value !== null) {
          if (Array.isArray(key.modifier.selected_value)) {
            key.modifier.selected_value.forEach(function (item) {
              self.price = Number(self.price) + Number(item.price)
            })
          } else if (key.modifier.selected_value) {
            self.price = Number(self.price) + Number(key.modifier.selected_value.price)
          }
        }
      })

      this.selected_complete_your_meal_products.map((product) => {
        self.price = Number(self.price) + Number(product.totalPrice)
      })

    },
    formatPrice (value) {
      const val = (value / 1).toFixed(2)
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    resetForm () {
      this.name = ''
      this.description = ''
      if (Array.isArray(this.hasModifiers)) {
        this.hasModifiers.forEach(function (key) {
          key.modifier.selected_value = null
        })
      }
      if (this.size !== null) {
        this.size_selected_value = null//{label: 'Please select a size', value: 0, price: '0'}
      }
      this.hasModifiers = []
      this.size = null
      this.quantity = 1

      this.complete_your_meal_products = null
      this.selected_complete_your_meal_products = []

      this.errors.clear()
    },
    checkModifiers () {
      this.errors.clear()
      let error_ref = null
      let result = true
      const mod_array = JSON.parse(JSON.stringify(this.hasModifiers))
      mod_array.map(modifier_val => {
        const modifier = modifier_val.modifier
        if (!modifier.selected_value) {
          modifier.selected_value = []
        }
        if (modifier.required_choice === 1) {
          if (modifier.how_many_choices === 4) {
            if (modifier.min_choice > modifier.selected_value.length) {
              result = false
              const str = `You have to choose minimum ${modifier.min_choice} item${modifier.min_choice > 1 ? 's' : ''} to proceed`
              this.errors.add({
                field: `mod${modifier.id}`,
                msg: str
              })

              if (!error_ref) {
                error_ref = `mod${modifier_val.id}`
              }

              //this.openAlert(modifier.name, str, () => {})
            }
          } else if (modifier.how_many_choices === 2) {
            if (!modifier.selected_value || Array.isArray(modifier.selected_value)) {
              result = false
              const str = 'You have to choose minimum 1 item to proceed'
              this.errors.add({
                field: `mod${modifier.id}`,
                msg: str
              })
              if (!error_ref) {
                error_ref = `mod${modifier_val.id}`
              }
              //this.openAlert(modifier.name, 'You have to choose minimum 1 item to proceed', () => {})
            }
          }
        }
      })

      if (error_ref) {
        this.goToSection(error_ref)
      }

      return result
    },
    goToSection (value) {
      document.getElementById(value).scrollIntoView({
        behavior: 'smooth'
      })
      /*const top = this.$refs[(value)].offsetTop
      window.scrollTo({
        top,
        left: 0,
        behavior: 'smooth'
      })*/
    },
    submitData () {
      this.isCaterValid = this.checkCateringIntersection(() => {
        this.isSidebarActiveLocal = true
        this.isCaterValid = true
        this.$store.commit('eCommerce/SET_CART', [])
        this.submitCheckRestaurant()
      }, () => {
        this.isSidebarActiveLocal = true
        this.$vs.notify({
          color:'danger',
          title:'Failed',
          text:'Failed to add product in cart'
        })
      })

      if (this.isCaterValid) {
        this.submitCheckRestaurant()
      }
    },
    submitCheckRestaurant () {
      this.isAlertOff = this.checkCartRestaurantIntersection(() => {
        this.isSidebarActiveLocal = true
        this.$store.commit('eCommerce/SET_CART', [])
        this.isAlertOff = true
        this.submitCont()
      }, () => {
        this.isSidebarActiveLocal = true
        this.$vs.notify({
          color:'danger',
          title:'Failed',
          text:'Failed to add product in cart'
        })
      })
      if (this.isAlertOff) {
        this.submitCont()
      }
    },
    submitCont () {
      if (this.isAlertOff) {
        const check_mods = this.checkModifiers()
        if (check_mods) {
          this.$validator.validateAll().then(result => {
            if (result) {
              const cartObject = JSON.parse(JSON.stringify(this.dataProp))
              cartObject.modifiers = this.hasModifiers
              cartObject.hasModifiers = this.hasModifiers
              cartObject.size = this.size
              cartObject.quantity = this.quantity

              if (this.dataProp.edit !== true) {
                this.selected_complete_your_meal_products.map((product) => {
                  this.$store.dispatch('eCommerce/additemInCart', product)
                })
                this.$store.dispatch('eCommerce/additemInCart', cartObject)
              } else {
                this.$store.dispatch('eCommerce/updateItemInCart', cartObject)
              }

              this.$vs.notify({
                title: 'Success',
                text: 'Item added to your cart',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })
              this.isSidebarActiveLocal = false
              this.$store.commit('TOGGLE_IS_SIDE_MENU_ACTIVE', true)

            }
          })
        }
      }
    },
    checkCateringIntersection (accept, cancel) {

      if (this.cartItems.length > 0) {
        const notSameCater = this.dataProp.is_catering !== (this.isCatering ? 1 : 0)


        if (notSameCater) {
          this.openConfirm(accept, cancel)
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    checkCartRestaurantIntersection (accept, cancel) {

      const sameRes = this.cartItems.find(x => x.restaurant_id !== this.restaurantId)


      if (sameRes) {
        this.openConfirm(accept, cancel)
        return false
      } else {
        return true
      }
    },
    openConfirm (accept, cancel) {
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'This action will reset your cart. Do you want to proceed?',
        accept,
        cancel
      })
    },
    acceptAlert () {
      this.$store.commit('eCommerce/SET_CART', [])
      this.$vs.notify({
        color:'danger',
        title:'Cart',
        text:'Cleared'
      })
    },
    getSizeOptionsForSelect (size) {
      const list = size.items
      const opt_list = []
      if (list !== 'undefined') {
        list.forEach(function (key) {

          let name = key.name
          if (key.price !== '0') {
            name = name.concat(' - $').concat(key.price)
          }
          opt_list[key.id] = {label: name, value: key.id, price: key.price}
        })
      }

      return opt_list
    },
    getModifierOptionsForSelect (modifier) {
      const list = modifier.items
      let opt_list = []
      if (list !== 'undefined') {
        list.forEach(function (key) {
          const key_id = key.id
          let name = key.name
          if (key.price !== '0') {
            name = name.concat(' - $').concat(key.price)
          }
          opt_list[String(key_id)] = {label: name, value: key.id, price: key.price}
        })
      }

      if (modifier.how_many_choices !== 1 && Array.isArray(modifier.selected_value)) {
        if (modifier.max_choice === modifier.selected_value.length) {
          opt_list = []
        }
      }

      return opt_list
    },
    onModifierCheckChange (mod, index, mod_item_index, e) {
      this.errors.clear()
      const modifier = mod.modifier

      if (modifier.how_many_choices === 4) {

        if (e.target.checked) {
          if (!modifier.selected_value) {
            modifier.selected_value = []
          }
          if (modifier.max_choice > modifier.selected_value.length) {
            modifier.selected_value.push({
              label: modifier.items[mod_item_index].name,
              value: modifier.items[mod_item_index].id,
              price: modifier.items[mod_item_index].price
            })
          } else {
            e.target.checked = false
            const mod_id = `mod${modifier.id}`
            const add = {
              field: mod_id,
              msg: 'You have reached the max limit for this item'
            }
            this.errors.add(add)
            setTimeout(() => {
              if (this.errors.has(mod_id)) {
                this.errors.remove(mod_id)
              }
            }, 4000)

            //this.openAlert(modifier.name, 'You have reached the max limit for this item', () => {})
          }
        } else if (modifier.selected_value) {
          const remove_item = modifier.selected_value.find(x => x.value === modifier.items[mod_item_index].id)
          const remove_index = modifier.selected_value.indexOf(remove_item)
          modifier.selected_value.splice(remove_index, 1)
        }
      } else if (modifier.how_many_choices === 3) {
        if (e.target.checked) {
          if (!modifier.selected_value) {
            modifier.selected_value = []
          }
          modifier.selected_value.push({
            label: modifier.items[mod_item_index].name,
            value: modifier.items[mod_item_index].id,
            price: modifier.items[mod_item_index].price
          })

        } else if (modifier.selected_value) {
          const remove_item = modifier.selected_value.find(x => x.value === modifier.items[mod_item_index].id)
          const remove_index = modifier.selected_value.indexOf(remove_item)
          modifier.selected_value.splice(remove_index, 1)
        }
      } else if (modifier.how_many_choices === 2) {
        if (e.target.checked) {
          if (modifier.selected_value && !Array.isArray(modifier.selected_value)) {
            e.target.checked = false
            //this.openAlert(modifier.name, 'You have reached the max limit for this item', () => {})
            const mod_id = `mod${modifier.id}`
            const add = {
              field: mod_id,
              msg: 'You have reached the max limit for this item'
            }
            this.errors.add(add)
            setTimeout(() => {
              if (this.errors.has(mod_id)) {
                this.errors.remove(mod_id)
              }
            }, 4000)
          } else {
            modifier.selected_value = {
              label: modifier.items[mod_item_index].name,
              value: modifier.items[mod_item_index].id,
              price: modifier.items[mod_item_index].price
            }
          }
        } else if (modifier.selected_value) {
          modifier.selected_value = null
        }
      }


      mod.modifier = modifier
      this.hasModifiers[index] = mod

      this.handlePriceChange()
    },
    onModifierChange (mod, index, e) {
      const modifier = mod.modifier
      if (modifier.how_many_choices === 2) {
        //modifier.selected_value = e
        modifier.selected_value = e
      }
      mod.modifier = modifier
      this.hasModifiers[index] = mod

      this.handlePriceChange()
    },
    onSizeChange (size, e) {
      size.selected_value = e
      this.size_selected_value = e
      this.handlePriceChange()
    },
    isModifierRequired (modifier) {
      let result = ''
      if (modifier.modifier.required_choice === 1) {
        if (Array.isArray(modifier.modifier.selected_value)) {
          if (modifier.modifier.selected_value.length < modifier.modifier.min_choice) {
            result = 'required'
          }
        } else {
          result = 'required'
        }

      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.cater-option{
  display:flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom:15px;
  .cater-option-col{
    margin-right:10px;
    &:last-child{
      margin-right:0px;
    }
    select{
      padding:8px 0px;
      font-weight: bold;
      color:#333;
      border-color:#ccc;
      width:100px;
      text-align: center;
      border-radius: 7px;
    }
  }
}
.tr-size-section {
  flex-wrap:wrap;
  align-items:center;
}
.tr-size-section-label{
  display:inline-flex;
  width:100%;
  margin-bottom:15px;
  * {
    display:inline-block;
  }
}
.modifier .vs-input--label {
  font-size:18px;
  margin-bottom:10px;
  display: block;
  font-weight: bold;
}
.modifier.required{
  padding:35px 10px 10px 10px !important;
  background-color:#f2f2f2;
  position:relative;
}
.modifier {
  margin-bottom:15px;
}
.required .vs-input--label:after{
  content:"Required";
  display:block;
  padding:5px 10px;
  font-weight: normal;
  font-size:14px;
  position:absolute;
  right:0px;
  top:0px;
  color:orange;
  background-color:#333;
}

.add-new-data-sidebar {

  .product-info {
    max-height: 62.5vh;
    padding:20px 20px 200px 20px;
  }

  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}
.vs-sidebar--items {

  .vs-input--label {
    padding-left: 0;
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}


div.v-select {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.size-item .v-select {
  flex: 1;
}

.img-padding {
  padding: 20px 10px;
}

.vs-sidebar {
  .img-container {
    max-height: 300px;
    overflow: hidden;
  }

}

.padding-spacer {
  padding: 0 5px 20px 0;
}

.vs-sidebar--footer button{
  flex: 1;
}
.scroll-area--data-list-add-new {
  height: unset;
}
.mobile .scroll-area--data-list-add-new {
  height: unset;
}

.price-wrapper {
  width: 100%;
  background: white;
  padding: 10px 0;
}
.mobile .price-wrapper {
  position: absolute;
  width: 100%;
  bottom: 60px;
}
.align-top-wrapper {
  position: absolute;
  top:0;
  left:0;
  right:0;
  background: #fff;
}
.img-container {
  border-radius:0 !important;
}

@media (max-width: 700px) {

  .scroll-area--data-list-add-new {
    flex:1;
    height: unset !important;
    overflow-y: auto;
  }

  .padding-spacer {
    padding: 0 5px 10px 0 !important;
  }

}

.price-wrapper {
  width: 100%;
  background: #333;
  padding: 20px;
  * {
    color:#fff !important;
    font-size:22px;
  }

}
.product-pop-cont.active {
  display:flex;
}
.product-pop-cont {
  position:fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width:100%;
  height:100vh;
  z-index: 45000;
  display: none;
  justify-content: center;
  align-items:center;
  background-color:rgba(0,0,0,.35);
  * {
    box-sizing: border-box;
  }
}
.pop-product-image {
  width:100%;
  height:250px;
  background-position: center;
  background-size:cover;
}
.pop-frame{
  position:relative;
  background-color:#fff;
  width:600px;
  min-height:400px;
  max-height:80vh;
  padding:0px 10px 0px 10px;
  border-radius: 7px;
}
.pop-top{
  display:flex;
  justify-content: space-between;
  align-items:center;
  padding:20px;
  height:50px;
  position:absolute;
  top:0;
  left:0;
  width:100%;
  background:#fff;
  box-shadow: 0px 3px 5px 0px rgba(0, 0, 0, .2);
  z-index:1;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
}
.pop-footer{
  display:flex;
  justify-content: space-between;
  align-items:center;
  padding:20px;
  height:100px;
  position:absolute;
  bottom:0;
  left:0;
  width:100%;
  background:#fff;
  box-shadow: 0px -3px 5px 0px rgba(0, 0, 0, .2);
  z-index: 999;
  border-bottom-right-radius: 7px;
  border-bottom-left-radius: 7px;
}
.pop-main {
  padding:60px 0px 110px 0px;
  max-height: calc(80vh - 170px);
  overflow:scroll;
}
.pop-main::-webkit-scrollbar{
  display:none;
}
.pop-add-button{
  display:flex;
background-color:#0070eb;
color:#fff;
font-weight: bold;
padding:10px;
cursor:pointer;
font-size:14px;
justify-content: center;
align-items: center;
width:50%;
border-radius: 7px;
}
.pop-add-item{
width:100%;
text-align: center;
}
.pop-quantity{
  width:50%;
  padding-right:20px
}
.quantity-button{
  border:1px solid #ccc;
  width:100%;
  height:36px;
  border-radius: 7px;
  button{
    &:first-child{
      border-top-left-radius:7px;
      border-bottom-left-radius:7px;
    }
    &:last-child{
      border-top-right-radius:7px;
      border-bottom-right-radius:7px;
    }
  width:30%;
  border:none;
  background-color:#f2f2f2;
  height: 100%;
  margin:0;
  text-align:center;
  font-size:22px;
  &:active{
    background-color:#0070eb;
    color:#fff;
  }
  }
  input{
    width:40%;
    border:none;
    text-align: center;
    font-size:22px;
    }
}
.pop-product-name{
  span{
    margin-bottom:20px;
  }
  h2{
    margin-bottom:20px;
  }
  margin-top:20px;
  margin-bottom:20px;
}
@media (max-width:768px){
  .pop-main{
    max-height: calc(80vh - 128px);
  }
  .pop-frame{
    width:90%;
  }
}
@media (max-width:340px){
  .pop-product-image{
    height:100px;
  }
}
</style>
